import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "rootElement",
  class: "valuations-map-container"
}
const _hoisted_2 = { class: "map-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "map-spinner-control"
}
const _hoisted_4 = { class: "map-top-panel" }
const _hoisted_5 = { class: "map-control d-flex justify-content-center" }
const _hoisted_6 = { class: "map-clickable d-flex gap-3" }
const _hoisted_7 = { class: "h-100 d-flex flex-column" }
const _hoisted_8 = { class: "flex-grow-1 overflow-auto" }
const _hoisted_9 = {
  key: 0,
  class: "list-group list-group-flush"
}
const _hoisted_10 = { class: "d-flex align-items-start" }
const _hoisted_11 = {
  key: 0,
  class: "valuation-image me-3"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "valuation-info flex-grow-1" }
const _hoisted_14 = { class: "valuation-title" }
const _hoisted_15 = { class: "valuation-details small" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "valuation-price-section mt-2" }
const _hoisted_18 = {
  key: 0,
  class: "valuation-price"
}
const _hoisted_19 = {
  key: 1,
  class: "valuation-share text-muted"
}
const _hoisted_20 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_21 = { class: "text-end mt-2" }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 1,
  class: "zoom-prompt-overlay"
}
const _hoisted_24 = { class: "map-legend" }
const _hoisted_25 = { class: "map-legend-content" }
const _hoisted_26 = { class: "legend-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LControlZoom = _resolveComponent("LControlZoom")!
  const _component_LMap = _resolveComponent("LMap")!
  const _component_EstateTypeControl = _resolveComponent("EstateTypeControl")!
  const _component_DateRangeControl = _resolveComponent("DateRangeControl")!
  const _component_LeftPanel = _resolveComponent("LeftPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LMap, {
        center: _ctx.centerLatLng,
        zoom: _ctx.zoom,
        options: _ctx.mapOptions,
        class: "valuations-map",
        ref: "map",
        "onUpdate:zoom": _ctx.updateZoom,
        "onUpdate:bounds": _ctx.handleBoundsChange,
        onClick: _ctx.handleMapClick,
        onReady: _ctx.onMapReady
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LControlLayers, { position: "topright" }),
          _createVNode(_component_MapyCzBasicLayer),
          _createVNode(_component_MapyCzOrthoPhotoLayer, { visible: false }),
          _createVNode(_component_LControlZoom, { position: "topleft" })
        ]),
        _: 1
      }, 8, ["center", "zoom", "options", "onUpdate:zoom", "onUpdate:bounds", "onClick", "onReady"]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", {
              class: "spinner-border spinner-border-sm",
              role: "status"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_EstateTypeControl, {
              estateTypes: _ctx.estateTypes,
              onChange: _ctx.estateTypeChange
            }, null, 8, ["estateTypes", "onChange"]),
            _createVNode(_component_DateRangeControl, {
              onChange: _ctx.dateRangeChange,
              defaultDateRange: _ctx.dateRange
            }, null, 8, ["onChange", "defaultDateRange"])
          ])
        ])
      ]),
      _createVNode(_component_LeftPanel, {
        visible: _ctx.activeMarker !== null
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-lg btn-link align-self-end",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-times" }, null, -1)
            ]))]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.activeMarker !== null)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedValuations, (valuation) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: valuation.id,
                        class: "list-group-item valuation-item"
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          (valuation.image)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("img", {
                                  src: valuation.image,
                                  alt: valuation.title,
                                  class: "rounded"
                                }, null, 8, _hoisted_12)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", {
                              class: "badge mb-1",
                              style: _normalizeStyle(_ctx.estateTypeBadgeStyle(valuation.estateType))
                            }, _toDisplayString(_ctx.getEstateTypeLabel(valuation.estateType)), 5),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(valuation.title), 1),
                            _createElementVNode("table", _hoisted_15, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-muted pe-2" }, "Účel", -1)),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.getPurposeOfValuationLabel(valuation.purposeOfValuation)), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-muted pe-2" }, "Odhadce", -1)),
                                  _createElementVNode("td", null, _toDisplayString(valuation.userName), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-muted pe-2" }, "Vytvořeno", -1)),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(valuation.createdAt)), 1)
                                ]),
                                (valuation.updatedAt)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                      _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-muted pe-2" }, "Změněno", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(valuation.updatedAt)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("tr", null, [
                                  _cache[7] || (_cache[7] = _createElementVNode("td", { class: "text-muted pe-2" }, "Oceněno", -1)),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(valuation.valuationDate)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              (_ctx.getValuationDetail(valuation.id))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.getValuationDetail(valuation.id).price)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "valuation-price-label" }, "Cenový odhad", -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.formatPrice(_ctx.getValuationDetail(valuation.id).price)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.getValuationDetail(valuation.id).share)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Podíl: " + _toDisplayString(_ctx.getValuationDetail(valuation.id).share.formatted), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_ctx.isLoadingDetail(valuation.id))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[9] || (_cache[9] = [
                                      _createElementVNode("div", {
                                        class: "spinner-border spinner-border-sm",
                                        role: "status"
                                      }, [
                                        _createElementVNode("span", { class: "visually-hidden" }, "Načítání...")
                                      ], -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("a", {
                                href: _ctx.getDetailPageUrl(valuation.id),
                                target: "_blank",
                                class: "valuation-detail-link"
                              }, [...(_cache[10] || (_cache[10] = [
                                _createTextVNode(" Zobrazit detail ", -1),
                                _createElementVNode("span", { class: "fas fa-angle-right ms-1 estimate-detail-link-icon" }, null, -1)
                              ]))], 8, _hoisted_22)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      (_ctx.zoomTooSmall)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("div", { class: "zoom-prompt-message" }, " Pro zobrazení odhadů přibližte mapu ", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEstateTypes, (type) => {
            return (_openBlock(), _createElementBlock("div", {
              key: type,
              class: "legend-item"
            }, [
              _createElementVNode("span", {
                class: "legend-marker",
                style: _normalizeStyle({ backgroundColor: _ctx.getEstateTypeColor(type) })
              }, null, 4),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getEstateTypeLabel(type)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 512))
}